import { useTranslation } from 'react-i18next';

import RRuleGenerator from 'react-rrule-generator';
import RRulePTBR from 'i18n/rrule/pt-br';

const RRuleForm = ({ show = true, disabled, onChange = () => {}, value }) => {
  const { i18n } = useTranslation();

  if (!show) return null;

  const translations = () => {
    if (i18n.language === 'ptBr') {
      return RRulePTBR;
    }
  };

  return (
    <div className="mt-2 rrule-container">
      <RRuleGenerator translations={translations()} disabled={disabled} value={value} onChange={onChange} />
    </div>
  );
};

export default RRuleForm;
